<template>
  <page>
    <span slot="page-title">Data Dictionary</span>
    <v-text-field
      name="header-slot"
      v-model="search"
      label="Search"
      single-line
      outlined
      dense
      hide-details
      style="max-width: 300px;"
      class="mb-2"
    ></v-text-field>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="items"
          :optiona="{}"
          :search="search">
          <template slot="items" slot-scope="{ item }">
            <tr :id="item.name.trim().toLowerCase().replace(/ /g, '-')">
              <td>{{ item.name }}</td>
              <td>{{ item.house }}</td>
              <td>{{ item.senate }}</td>
              <td>{{ item.president }}</td>
              <td>{{ item.factor }}</td>
              <td>{{ item.description }}</td>
              <td>{{ item.source }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </page>
</template>

<script>
import { Page } from '@/components'
import DataDictionary from '@/data_dictionary.json'

const name = 'data_dictionary'

const components = {
  Page
}

export default {
  name,
  components,
  metaInfo: {
    title: 'Data Dictionary'
  },
  data () {
    return {
      search: '',
      headers: [
        { text: 'Name', value: 'name', sortable: true },
        { text: 'House', value: 'house', sortable: true },
        { text: 'Senate', value: 'senate', sortable: true },
        { text: 'President', value: 'president', sortable: true },
        { text: 'Factor Category', value: 'factor', sortable: true },
        { text: 'Description', value: 'description', sortable: false },
        { text: 'Source', value: 'source', sortable: false }
      ],
      items: DataDictionary
    }
  },
  mounted () {
    if (this.$route.hash) {
      const scrollToHash = () => {
        const elem = document.getElementById(this.$route.hash.slice(1))
        const headerHeight = document.getElementById('header').offsetHeight
        const top = elem.getBoundingClientRect().top - headerHeight
        window.scrollTo(0, top)
      }
      scrollToHash()
    }
  }
}
</script>
